import * as types from "./habitese.actionType";

export default {
  setHabitese: data => ({
    type: types.SET_HABITESE,
    payload: data
  }),
  resetForm: () => ({
    type: types.HABITESE_RESET,
  }),
  getImprimirHabitese: () => ({
    type: types.GET_IMPRIMIR_HABITESE,
  }),
  getValidarHabitese: () => ({
    type: types.GET_VALIDAR_HABITESE,
  }),
  setDadosHabitese: data => ({
    type: types.SET_DADOS_HABITESE,
    payload: data
  }),
  getDadosHabitese: () => ({
    type: types.GET_DADOS_HABITESE,
  }),
}
